import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupUnion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconBooleanGroupUnion"><Path d="M10.75 2C9.23122 2 8 3.23122 8 4.75V8H4.75C3.23122 8 2 9.23122 2 10.75V19.25C2 20.7688 3.23122 22 4.75 22H13.25C14.7688 22 16 20.7688 16 19.25V16H19.25C20.7688 16 22 14.7688 22 13.25V4.75C22 3.23122 20.7688 2 19.25 2H10.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooleanGroupUnion;
